import { render, staticRenderFns } from "./participacion.vue?vue&type=template&id=490172a0"
import script from "./participacion.vue?vue&type=script&lang=ts"
export * from "./participacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports